export default __webpack_public_path__ + "static/media/oh1.5495cf8b.png";